import { bindable } from 'aurelia-framework';

class ProductFeedsJobsList {
  @bindable loading = false;
  @bindable account = null;
  @bindable onNewJobClick = () => {};
}

export { ProductFeedsJobsList };
